module.exports = __webpack_public_path__ + "static/img/logo.31585ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = eOq7
// module chunks = 30